import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'af',
  months: [
    'Januarie',
    'Februarie',
    'Maart',
    'April',
    'Mei',
    'Junie',
    'Julie',
    'Augustus',
    'September',
    'Oktober',
    'November',
    'Desember',
  ],
  monthsShort: ['Jan', 'Feb', 'Mrt', 'Apr', 'Mei', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Des'],
  weekdays: ['Sondag', 'Maandag', 'Dinsdag', 'Woensdag', 'Donderdag', 'Vrydag', 'Saterdag'],
  weekdaysMin: ['So', 'Ma', 'Di', 'Wo', 'Do', 'Vr', 'Sa'],
  weekdaysShort: ['So', 'Ma', 'Di', 'Wo', 'Do', 'Vr', 'Sa'],
  formats: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    lt: 'h:mm A',
    lts: 'h:mm:ss A',
    L: 'YYYY-MM-DD',
    LL: 'D MMMM YYYY',
    'LL-D': 'MMMM YYYY',
    'LL-Y': 'D MMMM',
    LLL: 'D MMMM YYYY HH:mm',
    'LLL-Y': 'D MMMM HH:mm',
    LLLL: 'dddd, D MMMM YYYY HH:mm',
    'LLLL-Y': 'dddd, D MMMM HH:mm',
    l: 'YYYY-M-D',
    'l-Y': 'M-D',
    ll: 'D MMM YYYY',
    'll-Y': 'D MMM',
    lll: 'D MMM YYYY h:mm A',
    'lll-Y': 'D MMM h:mm A',
    llll: 'ddd, D MMM YYYY h:mm A',
    'llll-Y': 'ddd, D MMM h:mm A',
    'll-Y+w': 'ddd D MMM',
    'LT+to': 'HH:mm ([GMT]Z)',
    'LLL+to': 'DD MMMM YYYY HH:mm ([GMT]Z)',
  },
  meridiem: { am: 'vm.', pm: 'nm.', AM: 'vm.', PM: 'nm.' },
  past: {
    y: { one: '%s j. gelede', other: '%s j. gelede' },
    M: { one: '%s md. gelede', other: '%s md. gelede' },
    w: { one: '%s w. gelede', other: '%s w. gelede' },
    d: { one: '%s dag gelede', other: '%s dae gelede' },
    h: { one: '%s u. gelede', other: '%s u. gelede' },
    m: { one: '%s min. gelede', other: '%s min. gelede' },
    s: { one: '%s s. gelede', other: '%s s. gelede' },
  },
  future: {
    y: { one: 'oor %s j.', other: 'oor %s j.' },
    M: { one: 'oor %s md.', other: 'oor %s md.' },
    w: { one: 'oor %s w.', other: 'oor %s w.' },
    d: { one: 'oor %s dag', other: 'oor %s dae' },
    h: { one: 'oor %s u.', other: 'oor %s u.' },
    m: { one: 'oor %s min.', other: 'oor %s min.' },
    s: { one: 'oor %s s.', other: 'oor %s s.' },
  },
  abbr: {
    y: { one: '%s j.', other: '%s j.' },
    M: { one: '%s md.', other: '%s md.' },
    w: { one: '%s w.', other: '%s w.' },
    d: { one: '%s dag', other: '%s dae' },
    h: { one: '%s u.', other: '%s u.' },
    m: { one: '%s min.', other: '%s min.' },
    s: { one: '%s s.', other: '%s s.' },
  },
  justNow: 'So pas',
  yesterday: 'Gister',
  today: 'Vandag',
  tomorrow: 'Môre',
  weekStart: 0,
};
const localeName: LocaleName = 'af';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  meridiem: (hour, _, isLowerCase = false): string => {
    if (hour < 12) {
      return isLowerCase ? 'vm.' : 'vm.';
    } else {
      return isLowerCase ? 'nm.' : 'nm.';
    }
  },
};
